<!--
  (c) Copyright 2024 Calabrio, Inc.
  All Rights Reserved. www.calabrio.com LICENSED MATERIALS
  Property of Calabrio, Inc., Minnesota, USA

  No part of this publication may be reproduced, stored or transmitted,
  in any form or by any means (electronic, mechanical, photocopying,
  recording or otherwise) without prior written permission from Calabrio, Inc.
-->

<template>
    <functional-calendar
      ref="calendarPicker"
      v-model="parent.calendarB"
      :is-multiple='true' 
      :calendars-count="4"
      :limits="dateLimits"
      :is-date-range='true'
      date-format="yyyy-mm-dd"
      @input="handleDateChange"
    />
</template>

<script>
import Vue from 'vue';
import { mapGetters } from 'vuex';
import moment from 'moment';
import FunctionalCalendar from '../../widgets/functional-calendar/FunctionalCalendar'

export default Vue.extend({
  name: 'wy-interactions-compare-metrics-cal-a',
  props: ['parent'],
  components: {
    'functional-calendar': FunctionalCalendar,
  },

  data() {
    return {
      dateRnage: {},
      availableDateRange: {min: "", max: ""},
      loadCalender: false
    }
  },

  computed: {
    ...mapGetters(['dataModel']),

    dateLimits() {
      if(this.dataModel.dateMin && this.dataModel.dateMax) {
        return {min: this.dataModel.dateMin, max: this.dataModel.dateMax};
      }
      else {
        return null;
      }
    },
  },

  methods: {
    initCalendar() {
      let dateObj = this.dataModel.dateMax ? moment(this.dataModel.dateMax).subtract(3, 'month') : moment().subtract(3, 'month');
      if(this.parent.calendarB.dateRange.start != "" && this.parent.calendarB.dateRange.end != "") {
        let startObj = moment(this.parent.calendarB.dateRange.start);
        let endObj = moment(this.parent.calendarB.dateRange.end);
        this.$refs.calendarPicker.selectDateRange(startObj.format('YYYY-M-D'), endObj.format('YYYY-M-D'));
        this.$refs.calendarPicker.pickYear(startObj.toDate().getYear()+1900, 0);
        this.$refs.calendarPicker.pickMonth(startObj.toDate().getMonth(), 0);        
      }
      else {
        this.$refs.calendarPicker.pickYear(dateObj.toDate().getYear()+1900, 0);
        this.$refs.calendarPicker.pickMonth(dateObj.toDate().getMonth(), 0);        
      }
      this.parent.dateRangeDisplayB = "Month Day, Year";
      this.parent.isStep2Filled = false;
    },

    handleDateChange(calendar) {      
      if(this.parent.calendarB.dateRange.start != "" && this.parent.calendarB.dateRange.end != "") {
        let dateStart = moment(calendar.dateRange.start, 'YYYY-MM-D');
        let dateEnd = moment(calendar.dateRange.end, 'YYYY-MM-D');

        this.parent.dateRangeDisplayB = dateStart.format("MMM DD, YYYY") + ' - ' + dateEnd.format("MMM DD, YYYY");
        this.parent.isStep2Filled = true;        
      }
      else {
        this.parent.dateRangeDisplayB = "Month Day, Year";
        this.parent.isStep2Filled = false;        
      }

      setTimeout(() => {
        document.querySelectorAll(".vfc-base-start").forEach(el=> {
          if(el.nextSibling.nextSibling.classList.contains("vfc-hide")) {
            el.style.display = "none";
          }
          else {
            el.style.display = "block"
            el.style.backgroundColor="#004A87"
          }
        })
        document.querySelectorAll(".vfc-base-end").forEach(el=> {
          if(el.nextSibling.classList.contains("vfc-hide")) {
            el.style.display = "none";
          }
          else {
            el.style.display = "block"
            el.style.backgroundColor="#004A87"
          }
        })
      },200)
    },

    reset() {
      this.initCalendar();
      this.parent.isStep2Filled = false;
    },
  },

  mounted() {
    this.initCalendar();
  }
});
</script>